import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeOrderKebabMenu } from "../../../Features/orderManagementSlice";
import RejectReturnForm from "./RejectReturnForm";
import ExportModal from "./ExportModal";
import CallPickupModal from "./CallPickupModal";

const MODAL_COMPONENTS = {
  rejectReturn: RejectReturnForm,
  callPickup: CallPickupModal,
  export: ExportModal,
};

function Modal() {
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();

  const { activeModal, displayModal } = useSelector(
    (state) => state.orderManagement.modal
  );

  useEffect(() => {
    if (displayModal) {
      setVisible(true);
    } else {
      dispatch(closeOrderKebabMenu());
      setVisible(false);
    }
  }, [displayModal]);

  const ActiveModalComponent = MODAL_COMPONENTS[activeModal] || null;

  return (
    <div
      className={`${
        visible ? "opacity-100 visible bg-[#00000080]" : "opacity-0 invisible"
      } transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center`}
    >
      {ActiveModalComponent && <ActiveModalComponent />}
    </div>
  );
}

export default Modal;
